import React from 'react';
import { useI18n } from '../../../../../data/hooks/i18nHooks';
import { useCallback } from 'react';
import { ScaleInputStars } from '../../../../elements/forms/ScaleInput';

function LeadPriority(props) {
    const { lead, onChange } = props,
        i18n = useI18n();

    const handleChangePriority = useCallback((priority) => {
        onChange({priority})
    }, [onChange]);

    return (
        <>
            <label>{i18n['label.priority']}</label>
            <ScaleInputStars value={lead.priority} onChange={handleChangePriority} />
        </>
    );
}

export default LeadPriority;
